// extracted by mini-css-extract-plugin
export default {"container":"TabViewChooser_container__riUPw","selectorContainer":"TabViewChooser_selectorContainer__cEnWO"};